import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  container: {
    fill: '#adadad',
    cursor: 'pointer'
  },
  badge: {
    position: 'absolute',
    right: 6,
    color: '#fff',
    borderRadius: '50%',
    border: '2px solid #fff',
    fontWeight: 900,
    fontFamily: 'verdana',
    top: 6,
    backgroundClip: 'content-box'
  },
  noUploadingFiles: {
    fill: '#efefef',
    cursor: 'default'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/NavigationBar/Upload/styles.js